export default function capitalizeAllWords(str) {
    return str.toLowerCase().replace(/(^|\s|-)(‘|’|ʿ|ʽ|ˈ|ˌ|ʾ){0,3}([a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ])/g, s => s.toUpperCase());
}